import CreativeOrientationType from '@/common/enums/CreativeOrientationType.enum';
import Language from '@/common/models/misc-api-models/Language';
import Validatable from '@/validator/Validatable';

export interface IUnitPackInventoryTargetingAPI {
  inventorytargeting_id: number;
  owner_ids: number[];
  geofencegroup_ids: number[];
  geofencegroup_exclusion_ids: number[];
  unit_ids: number[];
  unit_exclusion_ids: number[];
  site_ids: number[];
  site_exclusion_ids: number[];
  location_ids: number[];
  location_exclusion_ids: number[];
  network_ids: number[];
  network_exclusion_ids: number[];
  market_ids: number[];
  market_exclusion_ids: number[];
  mediatype_ids: number[];
  mediatype_exclusion_ids: number[];
  unitpack_ids: number[];
  unitpack_exclusion_ids: number[];
  unit_tags: string[];
  unit_tag_exclusions: string[];
  creative_formats: string[];
  creative_format_exclusions: string[];
  language_ids: Language[];
  language_exclusion_ids: Language[];
  creative_orientations: CreativeOrientationType[];
  creative_orientation_exclusions: CreativeOrientationType[];
  iab_categories: string[];
  iab_category_exclusions: string[];
}

export default class UnitPackInventoryTargeting extends Validatable {
  constructor(
    public id = -1,
    public mediaOwnerIDs = [],
    public geofenceGroupIDs = [],
    public geofenceGroupExclusionIDs = [],
    public unitIDs = [],
    public unitExclusionIDs = [],
    public siteIDs = [],
    public siteExclusionIDs = [],
    public locationIDs = [],
    public locationExclusionIDs = [],
    public networkIDs = [],
    public networkExclusionIDs = [],
    public marketIDs = [],
    public marketExclusionIDs = [],
    public mediaTypeIDs = [],
    public mediaTypeExclusionIDs = [],
    public unitPackIDs = [],
    public unitPackExclusionIDs = [],
    public unitTags = [],
    public unitTagExclusions = [],
    public creativeFormats = [],
    public creativeFormatExclusions = [],
    public languageIDs = [],
    public languageExclusionIDs = [],
    public creativeOrientations = [],
    public creativeOrientationExclusions = [],
    public iabCategories = [],
    public iabCategoryExclusions = [],
  ) {
    super();
  }

  toApi(): IUnitPackInventoryTargetingAPI {
    return {
      inventorytargeting_id: this.id,
      owner_ids: this.mediaOwnerIDs,
      geofencegroup_ids: this.geofenceGroupIDs,
      geofencegroup_exclusion_ids: this.geofenceGroupExclusionIDs,
      unit_ids: this.unitIDs,
      unit_exclusion_ids: this.unitExclusionIDs,
      site_ids: this.siteIDs,
      site_exclusion_ids: this.siteExclusionIDs,
      location_ids: this.locationIDs,
      location_exclusion_ids: this.locationExclusionIDs,
      network_ids: this.networkIDs,
      network_exclusion_ids: this.networkExclusionIDs,
      market_ids: this.marketIDs,
      market_exclusion_ids: this.marketExclusionIDs,
      mediatype_ids: this.mediaTypeIDs,
      mediatype_exclusion_ids: this.mediaTypeExclusionIDs,
      unitpack_ids: this.unitPackIDs,
      unitpack_exclusion_ids: this.unitPackExclusionIDs,
      unit_tags: this.unitTags,
      unit_tag_exclusions: this.unitTagExclusions,
      creative_formats: this.creativeFormats,
      creative_format_exclusions: this.creativeFormatExclusions,
      language_ids: this.languageIDs,
      language_exclusion_ids: this.languageExclusionIDs,
      creative_orientations: this.creativeOrientations,
      creative_orientation_exclusions: this.creativeOrientationExclusions,
      iab_categories: this.iabCategories,
      iab_category_exclusions: this.iabCategoryExclusions,
    };
  }

  static fromApi(apiObject: IUnitPackInventoryTargetingAPI) {
    return new UnitPackInventoryTargeting(
      apiObject.inventorytargeting_id,
      apiObject.owner_ids,
      apiObject.geofencegroup_ids,
      apiObject.geofencegroup_exclusion_ids,
      apiObject.unit_ids,
      apiObject.unit_exclusion_ids,
      apiObject.site_ids,
      apiObject.site_exclusion_ids,
      apiObject.location_ids,
      apiObject.location_exclusion_ids,
      apiObject.network_ids,
      apiObject.network_exclusion_ids,
      apiObject.market_ids,
      apiObject.market_exclusion_ids,
      apiObject.mediatype_ids,
      apiObject.mediatype_exclusion_ids,
      apiObject.unitpack_ids,
      apiObject.unitpack_exclusion_ids,
      apiObject.unit_tags,
      apiObject.unit_tag_exclusions,
      apiObject.creative_formats,
      apiObject.creative_format_exclusions,
      apiObject.language_ids,
      apiObject.language_exclusion_ids,
      apiObject.creative_orientations,
      apiObject.creative_orientation_exclusions,
      apiObject.iab_categories,
      apiObject.iab_category_exclusions,
    );
  }
}
